// extracted by mini-css-extract-plugin
export default {"itemContent":"w5EFUiX9Ga","itemContent__text":"xcSaljmmQI"};